import { getStaticImageUrl } from './imageUrl'

export const DEFAULT_BACKGROUND = getStaticImageUrl(
  'social-card-backgrounds/default-background.png'
)

export const GRADIENT_IMAGE_URL = getStaticImageUrl(
  'social-card-backgrounds/default-gradient.png'
)

export const HERO_BACKGROUND_IMAGE_URL = getStaticImageUrl(
  'hero/background-bright.png'
)

// Background paths for use with getStaticImageUrl
export const BACKGROUNDS = [
  'social-card-backgrounds/purple-yellow.png',
  'social-card-backgrounds/pink-yellow.png',
  'social-card-backgrounds/blue-purple.png',
  'social-card-backgrounds/blue-teal.png',
  'social-card-backgrounds/purple-blue.png',
]
